"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfNotificationSectionDto = instanceOfNotificationSectionDto;
exports.NotificationSectionDtoFromJSON = NotificationSectionDtoFromJSON;
exports.NotificationSectionDtoFromJSONTyped = NotificationSectionDtoFromJSONTyped;
exports.NotificationSectionDtoToJSON = NotificationSectionDtoToJSON;
exports.NotificationSectionDtoToJSONTyped = NotificationSectionDtoToJSONTyped;
const NotificationTopicDto_1 = require("./NotificationTopicDto");
/**
 * Check if a given object implements the NotificationSectionDto interface.
 */
function instanceOfNotificationSectionDto(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('topics' in value) || value['topics'] === undefined)
        return false;
    return true;
}
function NotificationSectionDtoFromJSON(json) {
    return NotificationSectionDtoFromJSONTyped(json, false);
}
function NotificationSectionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'topics': (json['topics'].map(NotificationTopicDto_1.NotificationTopicDtoFromJSON)),
    };
}
function NotificationSectionDtoToJSON(json) {
    return NotificationSectionDtoToJSONTyped(json, false);
}
function NotificationSectionDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'description': value['description'],
        'topics': (value['topics'].map(NotificationTopicDto_1.NotificationTopicDtoToJSON)),
    };
}
//# sourceMappingURL=NotificationSectionDto.js.map